module.exports = __webpack_public_path__ + "img/banner.627c830e.png";